"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
function Body({ children, }) {
    return jsx_runtime_1.jsx("main", { children: children }, void 0);
}
exports.Body = Body;
//# sourceMappingURL=Body.js.map